import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import useCoveredSiblings from '../utils/useCoveredSiblings';
import { sentences } from '../../../shared/cartStartWait';
import '../styles/checkoutWaitPanel.css';

const CheckoutRetryPanel = ({ title, message, onRetry, onBack, backLabel }) => {
  const overlayRef = useRef(null);
  const retryRef = useRef(null);
  useCoveredSiblings(overlayRef);

  useEffect(() => {
    retryRef.current.focus();
  }, []);

  return (
    <div className="checkout-wait-overlay" ref={overlayRef}>
      <div className="checkout-wait-panel" role="alert">
        <p className="checkout-wait-panel-title">
          <strong>{title}</strong>
        </p>
        <div className="alert alert-danger">
          {sentences(message).map((sentence) => (
            <p key={sentence} className="mb-0">{sentence}</p>
          ))}
        </div>
        <button type="button"
                ref={retryRef}
                className="btn btn-danger checkout-wait-panel-retry"
                onClick={onRetry}>
          <strong>Try Again</strong>
        </button>
        <p className="mt-3 mb-0">
          <button type="button" className="btn btn-link p-0" onClick={onBack}>
            {backLabel}
          </button>
        </p>
      </div>
    </div>
  );
};

CheckoutRetryPanel.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  backLabel: PropTypes.string.isRequired,
};

export default CheckoutRetryPanel;
